/**
 * AppShell — composes the sidebar + topbar + supervised banner around the
 * outlet so every authenticated route shares the same chrome.
 *
 * Sysadmin variant per `docs/frontend/035-frontend-app-shell-plan.md §5.4`:
 * the shell still renders, but the sidebar's tenant sections are hidden
 * (the Sidebar component handles that internally) and the main area
 * surfaces a "support mode — no tenant context" banner above the outlet.
 */

import { Outlet } from 'react-router-dom';
import { useMeContext } from '../../context/MeContextProvider';
import { ClientScopeProvider } from '../../context/ClientScopeProvider';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { SupervisedBanner } from './SupervisedBanner';

function SysadminBanner() {
  return (
    <div
      role="status"
      style={{
        background: 'var(--sky-soft)',
        color: 'var(--sky-ink)',
        padding: '10px 18px',
        borderBottom: '1px solid var(--line-2)',
        fontSize: 12,
      }}
    >
      <strong>وضع دعم النظام.</strong> هذا الحساب System admin ولا يملك سياق وكالة. جميع صفحات
      العملاء سترجع 404.
    </div>
  );
}

export function AppShell() {
  const { me } = useMeContext();
  return (
    <ClientScopeProvider>
      <div className="shell">
        <Sidebar />
        <main className="main">
          <Topbar />
          {me?.system_admin ? <SysadminBanner /> : null}
          <SupervisedBanner />
          <div className="page">
            <Outlet />
          </div>
        </main>
      </div>
    </ClientScopeProvider>
  );
}
